/**
 * Error Handler para Sistema AI Inline
 * Centraliza tratamento de erros e notificações ao usuário
 */

import { toast } from '@/hooks/use-toast';

export interface AIError {
  type: 'network' | 'server' | 'validation' | 'abort' | 'unknown';
  message: string;
  status?: number;
  details?: any;
}

/**
 * Classificar e tratar erros de IA
 */
export function handleAIError(error: any): AIError {
  // Erro de rede ou Edge Function
  if (error?.message?.includes('Edge Function returned a non-2xx status code')) {
    const aiError: AIError = {
      type: 'server',
      message: 'Serviço de IA indisponível',
      status: 500,
      details: error
    };
    
    showErrorToast(aiError);
    return aiError;
  }
  
  // Requisição cancelada
  if (error?.name === 'AbortError' || error?.message?.includes('cancelada')) {
    const aiError: AIError = {
      type: 'abort',
      message: 'Operação cancelada',
      details: error
    };
    
    return aiError; // Não mostrar toast para cancelamentos
  }
  
  // Erro de validação
  if (error?.status === 400) {
    const aiError: AIError = {
      type: 'validation',
      message: error.message || 'Dados inválidos',
      status: 400,
      details: error
    };
    
    showErrorToast(aiError);
    return aiError;
  }
  
  // Erro genérico
  const aiError: AIError = {
    type: 'unknown',
    message: error?.message || 'Erro desconhecido na IA',
    details: error
  };
  
  showErrorToast(aiError);
  return aiError;
}

/**
 * Exibir toast de erro para o usuário
 */
function showErrorToast(error: AIError): void {
  const messages = {
    network: 'Problema de conexão. Verifique sua internet.',
    server: 'Serviço de IA temporariamente indisponível. Tente novamente.',
    validation: 'Por favor, selecione um texto para usar esta função.',
    unknown: 'Erro inesperado. Tente novamente em alguns instantes.'
  };
  
  toast({
    title: 'Erro na IA',
    description: messages[error.type] || error.message,
    variant: 'destructive',
  });
}

/**
 * Log estruturado de erros de IA
 */
export function logAIError(context: string, error: AIError, payload?: any): void {
  console.group(`❌ AI Error - ${context}`);
  console.error('Type:', error.type);
  console.error('Message:', error.message);
  if (error.status) console.error('Status:', error.status);
  if (payload) console.error('Payload:', payload);
  if (error.details) console.error('Details:', error.details);
  console.groupEnd();
}